import React, { useState, Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { linkTo } from "../utils/uiUtils";
import { LISTING_TYPE } from "../platformUtils";
import { useAcreDapp } from "../providers/AcreDappProvider/AcreDappProvider";
import useMostPopularProperties from "../hooks/useMostPopularProperties";
import useTrendingProperties from "../hooks/useTrendingProperties";
import useRecommendedProperties from "../hooks/useRecommendedProperties";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import CardWithImage from "../components/CardWithImage/CardWithImage";
import RoundedButton from "../components/RoundedButton/RoundedButton";
import SingleListingImg from "../media/Single.png";
import CollectionListingImg from "../media/Collection.png";
import PillButton from "../components/PillButton/PillButton";

function CreateListingLander() {
  const { walletAddress } = useAcreDapp();
  return (
    <>
      <Navbar />
      <div className="outer-container relative overflow-hidden h-full">
        <div className="inner-container  relative pb-20 sm:pb-24">
          <main className="header grid grid-cols-1 mx-auto max-w-7xl mt-16 sm:mt-24">
            <div className="text-center">
              <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
                <span className="block xl:inline">
                  Create <span className="text-logo-green">Listing</span>
                </span>{" "}
              </h1>
              <p className="pt-4 mx-auto mt-3 max-w-md text-base text-gray-500 sm:text-lg md:mt-5 md:max-w-3xl md:text-xl">
                Choose <span className="font-bold text-logo-green">Single</span>{" "}
                if you want your collectible to be one of a kind or{" "}
                <span className="font-bold text-logo-green">Collection</span> if
                you want to sell one
              </p>
            </div>
          </main>
          <div className="grid mt-20 sm:mt-32 gap-8 sm:gap-12 md:gap-20 lg:gap-24 grid-cols-1 sm:grid-cols-2">
            <div className="flex justify-center items-center gap-2">
              <CardWithImage
                image={SingleListingImg}
                children={
                  <RoundedButton
                    outline="true"
                    link={`/property/list/new/single`}
                    children={<h1 className="text-xl font-bold">Create Single</h1>}
                  />
                }
              />
            </div>
            <div className="flex justify-center items-center gap-2">
              <CardWithImage
                image={CollectionListingImg}
                children={
                  <RoundedButton
                    outline="true"
                    link="/property/list/new/collection"
                    children={<h1 className="text-xl font-bold">Create Collection</h1>}
                  />
                }
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default CreateListingLander;
